module.exports = __webpack_public_path__ + "img/admin-active.fac93470.svg";